import { Injectable } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { TranslateService } from '@ngx-translate/core';

@Injectable()
export class NotificationService {

  constructor(private _toastr: ToastrService, public translate: TranslateService) {
  }

  success(title: string, message: string) {
    this._toastr.success(message && this.translate.instant(message) || '',
      title && this.translate.instant(title) || '');
  }

  errorCustom(title: string, message: string) {
    this._toastr.error(message && this.translate.instant(message) || '',
      title && this.translate.instant(title) || '');
  }

  errorClient(message: string) {
    this._toastr.error(message && this.translate.instant(message) || '',
      this.translate.instant('MESSAGE.ERROR.CLIENT_ERROR_TITLE'));
  }

  errorServer(error: any) {
    this._toastr.error(error && this.translate.instant(error) || '',
      this.translate.instant('MESSAGE.ERROR.SERVER_ERROR_TITLE'));
  }

  warning(title: string, message: string) {
    this._toastr.warning(message && this.translate.instant(message) || '',
      title && this.translate.instant(title) || '');
  }

  info(message: string) {
    message && this._toastr.info(message && this.translate.instant(message) || '');
  }
}
